import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-useful-weeks',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './useful-weeks.component.html',
  styleUrl: './useful-weeks.component.scss',
})
export class UsefulWeeksComponent implements OnInit {
  @Input() weeksProgress: number = 0;
  @Input() maxWeeks: number = 80;

  ngOnInit(): void {
    // Puedes establecer valores por defecto aquí
    if (this.weeksProgress === 0) {
      this.setProgressUsefulWeeks(0);
    }
  }

  setProgressUsefulWeeks(newProgress: number): void {
    this.weeksProgress = Math.min(Math.max(newProgress, 0), this.maxWeeks);
  }

  setMaxUsefulWeeks(newMax: number): void {
    this.maxWeeks = newMax;
    // Asegurar que el progreso actual no exceda el nuevo máximo
    if (this.weeksProgress > this.maxWeeks) {
      this.weeksProgress = this.maxWeeks;
    }
  }

  getProgressPercentage(): number {
    return (this.weeksProgress / this.maxWeeks) * 100;
  }
}
